/**
 * 通用模块 store状态管理
 * @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
 * @link
 * @create 2018-03-15
 */


import * as types from './../mutation-types'

var state = {
  userInfo: localStorage['userInfo'] ?
    JSON.parse(localStorage['userInfo']) : null,
  // cartData: localStorage['cartData']
  //     ? JSON.parse(localStorage['cartData'])
  //     : [],
  demoT: '我是测试数据',
  title: '华润万家超市',
  isLoading: false,
  direction: 'xxxx' //forward  reverse
};

// 唯一改变状态的地方
var mutations = {
  [types.DEMO_TEST](state, tv) {
    state.demoT = tv
  },
  [types.UPDATE_USERINFO](state, {
    userInfo
  }) {
    state.userInfo = userInfo
  },
  [types.UPDATE_LOADING](state, status) {
    state.isLoading = status
  },
  [types.UPDATE_DIRECTION](state, direction) {
    state.direction = direction
  },
  [types.UPDATE_TITLE](state, title) {
    state.title = title
  }
};

// 包含异步操作(例如从后端拿到数据),
//改变状态必须commit   mutations去改变状态
//全局的  命名规范   模块名_ac_名称
var actions = {
  common_ac_setDemoT({
    commit,
    rootState
  }, tv) {
    commit(types.DEMO_TEST, tv);
  },
  /**设置页面是后退的状态 */
  common_ac_setPageDirectionForward({
    commit,
    rootState
  }) {
    commit(types.UPDATE_DIRECTION, 'forward');
  },
  /**设置页面是前进的状态 */
  common_ac_setPageDirectionReverse({
    commit,
    rootState
  }) {
    commit(types.UPDATE_DIRECTION, 'reverse');
  },
  /**设置页面是加载的状态 */
  common_ac_setPageLoadingTrue({
    commit,
    rootState
  }) {
    commit(types.UPDATE_LOADING, true);
  },
  /**设置页面是加载完毕的状态 */
  common_ac_setPageLoadingFalse({
    commit,
    rootState
  }) {
    commit(types.UPDATE_LOADING, false);
  },
  /**设置页面标题 */
  common_ac_setPageTitle({
    commit,
    rootState
  }, title) {
    commit(types.UPDATE_TITLE, title);
  }
};

// store里面的计算属性  全局的  命名规范   模块名_gt_名称
//模块名 加名称
var getters = {
  common_gt_demoTest(state, getters, rootState, rootGetters) {
    return state.demoT;
  },
  /**获取页面加载状态 */
  common_gt_pageLoading(state, getters, rootState, rootGetters) {
    return state.isLoading;
  },
  /** 获取页面加载方向
   */
  common_gt_pageDirection(state, getters, rootState, rootGetters) {
    return state.direction;
  },
  common_gt_userInfo(state, getters, rootState, rootGetters) {
    return state.userInfo;
  }

};

/**
 * actions, mutations, getters, 限定在当前模块的命名空间中。
 * 只要给我们的模块加一个namespaced 属性
 * 当所有的actions, mutations, getters
 * 都被限定到模块的命名空间下，我们dispatch actions,
 * commit mutations 都需要用到命名空间。
 * 如 dispacth("changeName"), 就要变成 dispatch("login/changeName");
 *  getters.localJobTitle 就要变成 getters["login/localJobTitle"]
 */
export default {
  // namespaced:true,  //这里不限定
  state,
  mutations,
  actions,
  getters
}

// export default {
//     state:{},
//     mutatons:{},
//     actions:{},
//     getters:{}
// }



// WEBPACK FOOTER //
// ./src/store/modules/common.js